module.exports = {
	"name": "watchespn-fe",
	"version": "1.1.3-0",
	"description": "watch redesign with react and redux",
	"keywords": [],
	"author": "Rob Wong <robert.m.wong@espn.com>",
	"main": "./js/main.js",
	"directories": {
		"test": "test"
	},
	"repository": {
		"type": "git"
	},
	"scripts": {
		"analyze": "npm run build:webpack:prod && webpack-bundle-analyzer -p 9999 ./dist/webpack.stats.json",
		"build": "npm run clean && npm run build:webpack:prod",
		"build:dev": "npm run clean && npm run build:webpack:dev",
		"build:webpack:prod": "NODE_ENV=production webpack --config ./config/webpack.prod.config.js --progress --profile --colors",
		"build:webpack:dev": "NODE_ENV=development webpack --config ./config/webpack.dev.config.js --progress --profile --colors",
		"build:webpack:server": "NODE_ENV=production webpack --config ./config/webpack.server.config.js --profile --colors",
		"clean": "rimraf dist",
		"lint": "eslint --cache .",
		"start": "NODE_ENV=production NODE_PATH=./app node server/server.bundle.js --no-daemon",
		"start:profile": "cross-env SCORETC_BACKCHANNEL_HOST=cdn.espn.com/core NODE_ENV=development NODE_PATH=./app 0x node --inspect server/server.bundle.js",
		"start:prod": "cross-env NODE_ENV=production NODE_PATH=./app babel-node server/server.js -i 0",
		"start:prod-local": "npm run build && npm run build:webpack:server && cross-env SCORETC_BACKCHANNEL_HOST=cdn.espn.com/core NODE_ENV=production NODE_PATH=./app PROD_LOCAL=true node server/server.bundle.js",
		"start:dev": "cross-env PAGE_SHELL_URL=http://glue-bc.prod.espninfra.starwave.com/core/watch/?pageShell=true SCORETC_BACKCHANNEL_HOST=cdn.espn.com/core NODE_ENV=development NODE_PATH=./app babel-node server/server.js",
		"start:dev:perf": "cross-env PAGE_SHELL_URL=http://glue-bc.prod.espninfra.starwave.com/core/watch/?pageShell=true SCORETC_BACKCHANNEL_HOST=cdn.espn.com/core NODE_ENV=development NODE_PATH=./app PERF_DEBUG=true babel-node server/server.js",
		"start:dev:inspect": "SCORETC_BACKCHANNEL_HOST=cdn.espn.com/core NODE_ENV=development NODE_PATH=./app babel-node --inspect server/server.js",
		"start:frontend": "cross-env SCORETC_BACKCHANNEL_HOST=cdn.espn.com/core NODE_ENV=development DEV_STYLES=true NODE_PATH=./app babel-node --inspect server/server.js ",
		"start:dev:pm2": "cross-env CDN_PATH=http://a-qa.espncdn.com/vwatchwebnode SCORETC_BACKCHANNEL_HOST=cdn.espn.com/core NODE_ENV=production NODE_PATH=./app pm2-docker start ecosystem.json --auto-exit --web 9090",
		"test": "cross-env NODE_PATH=./app mocha test/.setup.js app/**/*.test.js app/**/**/*.test.js server/**/*.test.js",
		"test:coverage": "npm run lint && karma start",
		"precommit": "npm run lint",
		"prepush": "npm test"
	},
	"devDependencies": {
		"babel-core": "6.21.0",
		"babel-eslint": "6.0.4",
		"babel-plugin-add-module-exports": "^0.1.2",
		"babel-plugin-lodash": "^2.2.1",
		"babel-plugin-system-import-transformer": "^2.0.0",
		"babel-plugin-transform-async-to-generator": "^6.22.0",
		"babel-plugin-transform-object-assign": "~6.8.0",
		"babel-plugin-transform-react-inline-elements": "~6.8.0",
		"babel-polyfill": "^6.23.0",
		"babel-preset-react-hmre": "^1.1.1",
		"babel-register": "^6.18.0",
		"chai": "^3.5.0",
		"chai-enzyme": "^0.6.1",
		"cross-env": "~3.1.3",
		"css-loader": "^0.23.1",
		"enzyme": "^2.7.0",
		"eslint": "^3.13.0",
		"eslint-config-airbnb": "^14.0.0",
		"eslint-loader": "^1.3.0",
		"eslint-plugin-import": "^2.2.0",
		"eslint-plugin-jsx-a11y": "^3.0.2",
		"eslint-plugin-promise": "^3.5.0",
		"eslint-plugin-react": "^6.10.3",
		"husky": "^0.13.3",
		"isparta-loader": "^2.0.0",
		"jsdom": "^9.9.1",
		"karma": "^1.5.0",
		"karma-chai-sinon": "^0.1.5",
		"karma-chrome-launcher": "^2.0.0",
		"karma-cli": "^1.0.1",
		"karma-coverage": "^1.1.1",
		"karma-mocha": "^1.3.0",
		"karma-mocha-reporter": "^2.2.2",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-tap-reporter": "0.0.6",
		"karma-webpack": "^2.0.2",
		"mocha": "^3.2.0",
		"nock": "^9.0.9",
		"nodemon": "^1.9.2",
		"react-addons-test-utils": "^15.4.2",
		"react-hot-loader": "^1.3.0",
		"sinon": "^1.17.7",
		"sinon-chai": "^2.8.0",
		"style-loader": "^0.13.1",
		"uglify-js": "^2.7.3",
		"webpack-bundle-analyzer": "^2.2.1",
		"webpack-clean": "^1.0.0",
		"webpack-dev-middleware": "^1.6.1",
		"webpack-dev-server": "^1.14.1",
		"webpack-hot-middleware": "^2.15.0",
		"why-did-you-update": "^0.0.8",
		"write-file-webpack-plugin": "^3.1.8"
	},
	"dependencies": {
		"babel-cli": "~6.18.0",
		"babel-loader": "~6.2.3",
		"babel-plugin-transform-inline-environment-variables": "~6.8.0",
		"babel-plugin-transform-object-assign": "~6.8.0",
		"babel-plugin-transform-object-rest-spread": "~6.8.0",
		"babel-plugin-transform-react-inline-elements": "~6.8.0",
		"babel-plugin-transform-runtime": "~6.8.0",
		"babel-preset-es2015": "~6.6.0",
		"babel-preset-react": "~6.5.0",
		"bluebird": "3.4.5",
		"cache-service-cache-module": "~1.2.3",
		"cheerio": "~0.22.0",
		"classnames": "~2.2.3",
		"compression": "~1.6.2",
		"cookie-cutter": "~0.2.0",
		"cross-env": "~3.1.3",
		"espn-web-player-bundle": "1.7.2",
		"express": "~4.14.0",
		"express-handlebars": "~3.0.0",
		"express-http-proxy": "~0.9.1",
		"express-validator": "~2.21.0",
		"handlebars": "~4.0.5",
		"helmet": "~2.1.1",
		"hoist-non-react-statics": "^1.2.0",
		"http-proxy-agent": "~1.0.0",
		"immutable": "~3.8.1",
		"intl": "^1.2.5",
		"json-loader": "~0.5.4",
		"kardia": "0.9.0",
		"lodash": "~4.17.4",
		"loglevel": "~1.4.1",
		"memcached": "~2.2.2",
		"moment": "~2.15.0",
		"moment-timezone": "~0.5.4",
		"morgan": "~1.7.0",
		"newrelic": "1.35.1",
		"rapscallion": "^2.1.0",
		"react": "15.4.2",
		"react-dom": "15.4.2",
		"react-helmet": "^4.0.0",
		"react-intl": "^2.2.3",
		"react-modal": "1.4.0",
		"react-redux": "^5.0.3",
		"react-router": "2.8.1",
		"react-router-redux": "4.0.7",
		"react-router-scroll": "~0.2.1",
		"redux": "3.6.0",
		"redux-logger": "2.7.0",
		"redux-thunk": "2.1.0",
		"reselect": "~2.5.4",
		"rimraf": "~2.5.2",
		"selectn": "~1.1.2",
		"snappy": "~5.0.5",
		"stats-webpack-plugin": "^0.3.1",
		"superagent": "2.1.0",
		"superagent-bluebird-promise": "3.0.2",
		"superagent-cache": "1.7.1",
		"watch-authenticators": "1.4.2",
		"watch-fanapi": "1.8.0",
		"watch-scorekeeper": "1.0.8",
		"webpack": "1.14.0",
		"webpack-node-externals": "^1.2.0"
	},
	"license": "ISC",
	"moduleRoots": [
		"app"
	]
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 510
// module chunks = 0